module.exports = __webpack_public_path__ + "img/plan7.6fd4a3e0.svg";